import Modal from 'react-modal';
import { toast } from 'react-toastify';
import api from '../../../../config';
import './index.css';

export default function ModalFinalizeSeparation({showModalFinishSeparation, customStyles, setShowModalFinishSeparation, id, setCarrying, setStatus, rows, URL, method}){
    function validateSeparationCompletion() {
        let valid = true;
        
        rows.map(element => {
          if (element.qtde_separada != 0 && element.integration == 'S') {
            element.id_caracteristica_produto.map(feature => {
              if (feature.valor == '') {
                valid = false;
              }
            });
          }
        });
        
        return valid;
      }

    function finishSeparation() {
        setCarrying(true);
        
        if (validateSeparationCompletion()) {
          api[method](URL)
          .then((response) => {
            setStatus(response.data.row.status);
            toast.success('Separação Finalizada com Sucesso.');
            setShowModalFinishSeparation(false);
            setCarrying(false);
          }).catch((error) => {
            if(error?.response?.data?.error?.message){
              toast.error(error?.response?.data?.error?.message);
            } else{
              toast.error('Ops! Ocorreu um erro.');
            }

            toast.error(error.response.data?.message);
            setCarrying(false);
          });
        } else {
          toast.error('Há itens que foram separados que não possuem valores para as características cadastradas');
          setCarrying(false);    
        }
      }

    return (
        <Modal
            isOpen={showModalFinishSeparation}
            onRequestClose={() => setShowModalFinishSeparation(false)}
            className="modal-separation-finalization"
            contentLabel="Finalizar Separação"
            ariaHideApp={false}
        >
          <h3 className="modal-separation-finalization__title">Deseja realmente finalizar a separação?</h3>
          <div className="modal-separation-finalization__buttons">
            <button type="button" className="buttonSubmit" onClick={finishSeparation}>Confirmar</button>
            <button type="button" className="buttonCancel" onClick={() => setShowModalFinishSeparation(false)}>Fechar</button>
          </div>
        </Modal>
    )
}